import { Injectable } from '@angular/core';
import { Recommendation, RecommendationDataService, RecommendationsMessageEnum } from '@frontend-site/recommendations/domain';
import { LicensesService } from './licenses.service';
import { MaintenanceService } from './maintenance.service';
import { tap } from 'rxjs';
import { UserDetails } from '@frontend-site/shared/data';

@Injectable({
    providedIn: 'root'
})
export class RecommendationService {
    constructor(
        private recommendationDataService: RecommendationDataService,
        private maintenanceService: MaintenanceService,
        private licensesService: LicensesService
    ) {}

    showRecommendations() {
        this.recommendationDataService
            .getDataRecommendations()
            .pipe(tap(([userDetails, recommendations]) => this.showRelevantRecommendations(userDetails, recommendations)))
            .subscribe();
    }

    private showRelevantRecommendations(userDetails: UserDetails, recommendations: Recommendation[]) {
        recommendations.forEach((r) => {
            if (this.needToShowMaintenanceRecommendation(userDetails, r)) {
                this.maintenanceService.showMaintenanceRecommendation(r);
            } else if (this.needToShowLicensesRecommendation(r)) {
                this.licensesService.showLicensesRecommendation(r);
            }
        });
    }

    private needToShowMaintenanceRecommendation(userDetails: UserDetails, recommendation: Recommendation): boolean {
        return (
            recommendation.messageType === RecommendationsMessageEnum.MODAL &&
            recommendation.popout &&
            userDetails.afterLogin &&
            recommendation.recommendationId === RECOMMENDATION_TYPE.SCHEDULED_MAINTENANCE.id
        );
    }

    private needToShowLicensesRecommendation(recommendation: Recommendation): boolean {
        return (
            recommendation.messageType === RecommendationsMessageEnum.FLOATING &&
            recommendation.recommendationName === 'account_renewal_reminder'
        );
    }
}

export const RECOMMENDATION_TYPE = { SCHEDULED_MAINTENANCE: { id: 103 } };
